import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, map } from 'rxjs';
import { AuthService } from '../../../auth/auth.service';
import { Theme, ThemeService } from '../../../services/theme.service';

@Component({
    selector: 'em-dashboard-header-user-dropdown',
    templateUrl: './dashboard-header-user-dropdown.component.html',
    styleUrls: ['./dashboard-header-user-dropdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DashboardHeaderUserDropdownComponent {
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  private readonly themeService = inject(ThemeService);

  readonly user$ = this.authService.user$;
  readonly theme$ = this.themeService.theme$;
  readonly canViewEvents$ = this.authService.canViewEvents$;
  readonly canViewMyOrganization$ = this.authService.isResellerAdmin$;
  readonly canViewAdminQuoteTemplates$ = this.authService.canManageAdminQuoteTemplates$;
  readonly eventsRoute$ = this.authService.canViewAdminOrgEvents$.pipe(
    map((canViewAdminOrgEvents) => canViewAdminOrgEvents ? ['/admin', 'events'] : ['/events']),
  );
  readonly isSuperAdmin$ = this.authService.isSuperAdmin$;
  readonly isOpen$ = new BehaviorSubject(false);
  readonly clickOutsideEnabled$ = new BehaviorSubject(false);

  onClose() {
    if(this.clickOutsideEnabled$.value) {
      this.isOpen$.next(false);
    }

    this.clickOutsideEnabled$.next(true);
  }

  onToggle() {
    const currentValue = this.isOpen$.value;

    this.clickOutsideEnabled$.next(currentValue);
    this.isOpen$.next(! currentValue);
  }

  onEscape() {
    this.isOpen$.next(false);
    this.clickOutsideEnabled$.next(false);
  }

  onNavigate(route: string[]): void {
    this.onClose();

    this.router.navigate(route);
  }

  onSetTheme(theme: Theme): void {
    this.themeService.setTheme(theme);
  }

  onSignOut(): void {
    this.authService.logout().subscribe();
  }
}
